import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#b2b6bc";
function AXL({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 19 19" fill={color}><path  d="M3.746 1.137L2.61 2.273l.602.579c.336.32 1.754 1.71 3.156 3.074C8.75 8.254 8.965 8.43 9.418 8.43c.27 0 .656-.082.86-.188.199-.105 1.671-1.512 3.277-3.117l2.902-2.918L14.25 0 9.566 4.684 7.226 2.34 4.884 0zM1.137 3.746l-1.07 1.07 4.617 4.618-2.344 2.34L0 14.116l1.098 1.098 1.109 1.098 3.106-3.04c3.277-3.21 3.425-3.425 3.105-4.28-.121-.31-5.957-6.317-6.145-6.317-.039 0-.546.48-1.136 1.07m12.617 1.833c-1.59 1.606-2.957 3.05-3.035 3.211-.082.164-.149.524-.149.793 0 .48.16.668 3.106 3.625l3.117 3.117L19 14.117l-2.273-2.277c-1.247-1.258-2.278-2.34-2.278-2.434 0-.082 1.047-1.152 2.305-2.367l2.312-2.223-1.07-1.07c-.59-.59-1.125-1.07-1.203-1.07-.082 0-1.445 1.312-3.04 2.902m-4.855 5.047c-.214.105-1.726 1.512-3.343 3.145l-2.946 2.957 1.11 1.097 1.097 1.11L9.5 14.25l4.684 4.684 1.109-1.11 1.11-1.113-2.981-2.969c-1.649-1.633-3.133-3.039-3.293-3.133-.375-.214-.734-.214-1.23.016m0 0" /></Svg>;
}
AXL.DefaultColor = DefaultColor;
export default AXL;